import React from 'react';
import { clsPrefix } from '../const';
import { CnStatisticValueBaseProps } from './types';

/**
 * 指标卡 主指标值
 * @param {*} props
 * @returns
 */
function CnStatisticBaseMainValue({
  children,
  value,
  valueColor,
  valueFormat,
  prefix,
  suffix,
  suffixStyle,
  CnFormat,
}: CnStatisticValueBaseProps) {
  const isValidValue = typeof value === 'number' || typeof value === 'string';

  return (
    <div className={`${clsPrefix}-main`}>
      {isValidValue && (
        <span className="cn-format-array-view2-content">
          {prefix ? <CnFormat value={{ text: prefix }} format="CnFormatText" /> : null}
          {isValidValue && (
            <CnFormat
              value={value}
              format="CnFormatNumber"
              {...{ color: valueColor, ...(valueFormat || null) }}
            />
          )}
          {suffix ? (
            <CnFormat value={{ ...(suffixStyle || null), text: suffix }} format="CnFormatText" />
          ) : null}
        </span>
      )}
      {children}
    </div>
  );
}

export default CnStatisticBaseMainValue;
